<div [formGroup]="f">
    <div class="expandCollapseContainer mb-1" [ngClass]="!enableFilter ? 'inputDisabled' : 'inputEnabled'">
        <button class="expandCollapseHeader filterButton mb-1" (click)="onDisplayCommodityFilter()">
            <strong>{{ 'commodity' | translate | async }}</strong>
            <ng-container *ngIf="displayCommodityFilter; else expandIcon">
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-collapse"></use>
            </svg>
            </ng-container>
            <ng-template #expandIcon>
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-expand"></use>
            </svg>
            </ng-template>
        </button>

        <div *ngIf="enableFilter && displayCommodityFilter">
            <div class="filterList pb-1">
                {{ this.commodity.value && (this.commodity.value)[0] ? (this.commodity.value)[0] : ''}}

                <span *ngIf="this.commodity.value.length > 1">
                    (+{{ this.commodity.value.length - 1 }}
                    {{ this.commodity.value.length === 2 ? 'other' : 'others' }})
                </span>
            </div>

            <mat-form-field appearance="outline" class="flex-child" color="accent">
                <mat-label>
                    {{ 'commodity' | translate | async }}
                </mat-label>
                <input matInput type="text" formControlName="tempCommodity" [matAutocomplete]="auto">

                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" showPanel="true"
                    (optionsScroll)="onScroll()">
                    <div *ngIf="tempCommodity.value == '' || tempCommodity.value == undefined" class="filter-item">
                        <!-- Added for accessibility - mat-option is required but if selected breaks the virtual drop-down -->
                        <mat-option (onSelectionChange)="toggleSelectAll($event)">
                            <mat-checkbox role="checkbox" class="customCheckbox" [checked]="updateAllSelected()" (change)="toggleSelectAll($event)"
                            (click)="$event.stopPropagation()">
                            {{ 'select.all' | translate | async }}
                        </mat-checkbox>
                        </mat-option>
                        
                    </div>
                    <div *ngFor="let item of filteredCommodities$ | async" class="filter-item">
                        <!-- Added for accessibility - mat-option is required but if selected breaks the virtual drop-down -->
                        <mat-option (onSelectionChange)="toggleSelection(item, $event)">
                            <mat-checkbox role="checkbox" class="customCheckbox" [checked]="isCommodityChecked(item)"
                                (change)="toggleSelection(item, $event)" (click)="$event.stopPropagation()">
                                {{ item._source.description }}
                            </mat-checkbox>
                        </mat-option>
                    </div>
                </mat-autocomplete>
            </mat-form-field>
            
        </div>
    </div>
</div>